export const WORKER_PAY_ROLE_EMPLOYMENT_COMPATIBILITY = {
  FULL_TIME: ['FULL_TIME', 'PERMANENT', 'FIXED_TERM'],
  PART_TIME: ['PART_TIME', 'PERMANENT', 'FIXED_TERM'],
  CASUAL: ['CASUAL'],
  CONTRACTOR: ['CONTRACTOR'],
  STUDENT: [],
  PLACEMENT: [],
} as const satisfies Record<string, readonly string[]>;

const PAID_EMPLOYEE_EMPLOYMENT_TYPES = new Set(['FULL_TIME', 'PART_TIME', 'CASUAL']);

/**
 * Worker employment is a factual hours/status vocabulary. Pay roles use the
 * award-rate vocabulary, where PERMANENT/FIXED_TERM can cover either full-time
 * or part-time workers. Student and placement facts are never treated as paid
 * award employment without an explicit factual correction. A legacy role with
 * no employment type applies only to paid employee types, never to a placement,
 * student, volunteer, contractor, or another non-employee type.
 */
export function workerEmploymentMatchesPayRole(
  workerEmploymentType: string | null | undefined,
  payRoleEmploymentType: string | null | undefined,
): boolean {
  const worker = String(workerEmploymentType ?? '')
    .trim()
    .toUpperCase();
  if (payRoleEmploymentType == null) {
    return PAID_EMPLOYEE_EMPLOYMENT_TYPES.has(worker);
  }
  const role = String(payRoleEmploymentType ?? '')
    .trim()
    .toUpperCase();
  const compatible = (
    WORKER_PAY_ROLE_EMPLOYMENT_COMPATIBILITY as Record<string, readonly string[] | undefined>
  )[worker];
  return compatible?.includes(role) === true;
}

export function workerEmploymentNeedsFactualRecovery(
  workerEmploymentType: string | null | undefined,
): boolean {
  const worker = String(workerEmploymentType ?? '')
    .trim()
    .toUpperCase();
  return worker === 'STUDENT' || worker === 'PLACEMENT';
}
